// extracted by mini-css-extract-plugin
module.exports = {"bootstrap_loading_container":"BootstrapLoading_bootstrap_loading_container__okW8b","bootstrap_loading_wrapper":"BootstrapLoading_bootstrap_loading_wrapper__NtZEZ"};